<template>
    <app-layout>
        <common-content-spacer height="small">
            <patient-top-detail :patientDetails="patientDetails" :insurances="insurancePlans"></patient-top-detail>
            <div class="patient-layout">
                <patient-tab
                    :activeTab="activeTab"
                    :patientId="patientId"
                    @toggle="toggleModal"
                    @open-direct-referral="openDirectReferral"
                ></patient-tab>
                <div class="patient-main">
                    <patient-tab-content
                        :activeTab="activeTab"
                        :patientDetails="patientDetails"
                        :patientId="patientId"
                        @toggle="toggleModal"
                        @update-patient="updatePatient"
                        @close-delete-patient="closeDeletePatientModal"
                        @open-direct-referral="openDirectReferral"
                    ></patient-tab-content>
                </div>
            </div>
            <direct-referral
                v-if="isDirectReferralModalOpen"
                :patientId="patientId ? Number(patientId) : null"
                :activePracticeType="directReferralPracticeType"
                @close="closeDirectReferral"
            ></direct-referral>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PatientTab from 'components/forms/patient/PatientTabs'
    import PatientTabContent from 'components/forms/patient/PatientTabContent'
    import PatientAPI from 'api/PatientAPI'
    import Store from '~/store'
    import PatientTopDetail from 'components/forms/patient/PatientTopDetail'
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'

    export default {
        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            PatientTab,
            PatientTabContent,
            PatientTopDetail,
            DirectReferral,
        },
        data() {
            return {
                insurancePlans: [],
                patientId: null,
                activeTab: 'profile',
                previousActiveTab: 'profile',
                patientDetails: {},
                isLoading: false,
                isDirectReferralModalOpen: false,
                directReferralPracticeType: null,
            }
        },
        methods: {
            openDirectReferral(practiceType) {
                this.directReferralPracticeType = practiceType
                this.isDirectReferralModalOpen = true
            },

            closeDirectReferral() {
                this.isDirectReferralModalOpen = false
                this.directReferralPracticeType = null
            },
            toggleModal(tab) {
                if (tab === 'summary' || tab === 'record-requests-inbox') {
                    return
                }
                if (tab === 'delete-patient') {
                    this.previousActiveTab = this.activeTab
                }
                this.activeTab = tab
            },
            closeDeletePatientModal() {
                this.activeTab = this.previousActiveTab
            },
            handlePatientDetailsError(err) {
                const isConnectionError =
                    err?.response?.data?.subCode === 'connection.not_found' ||
                    (Array.isArray(err?.response?.data) &&
                        err.response.data.some((d) => d.field === 'connection' || d.code === 'entity.not_found')) ||
                    err?.response?.code === 'unauthorized' ||
                    err?.response?._status === 401 ||
                    err?.response?._status === 403 ||
                    /not connected/i.test(err?.response?.message || '') ||
                    /no connection/i.test(err?.response?.message || '') ||
                    /not connected/i.test(err?.message || '')

                if (isConnectionError) {
                    const message = this.$t('pages.patient.details.notifications.not_connected')
                    sessionStorage.setItem('patient_connection_error_notification', message)
                    this.$router
                        .replace({
                            name: 'referrals.received',
                            query: { notConnected: '1' },
                        })
                        .catch(() => {})
                }
            },
            getPatientDetails() {
                if (!this.patientId) {
                    this.patientDetails = {}
                    return
                }
                this.isLoading = true
                const userId = this.$auth.getActiveMember()?.id || this.$auth.getUser()?.id
                if (!userId) {
                    this.isLoading = false
                    return
                }
                PatientAPI.getPatientDetails(this.patientId, userId)
                    .then((res) => {
                        this.patientDetails = res || {}
                    })
                    .catch((err) => {
                        this.handlePatientDetailsError(err)
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
            updatePatient() {
                this.getPatientDetails()
            },
        },
        watch: {
            '$route.params.id': {
                immediate: true,
                handler(newId) {
                    this.patientId = newId || null
                    if (this.patientId) {
                        this.getPatientDetails()
                    } else {
                        this.patientDetails = {}
                        this.activeTab = 'profile'
                    }
                },
            },
        },
        mounted() {
            this.insurancePlans = Store.getters['auth/getInsurancePlans'] || []
        },
    }
</script>
<style lang="css" scoped>
    .patient-layout {
        display: grid;
        grid-template-columns: 260px 1fr;
        gap: 24px;
    }

    .patient-main {
        min-width: 0;
        margin-top: 12px;
    }
</style>
